// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__QKuVJ","footer":"ModalCreateQualiphyProcedure_footer__27tR7","additionData":"ModalCreateQualiphyProcedure_additionData__17Mn6"};